import { Heading, Rule, Text, VerticalSpace } from '@arc-ui/components';
import { SearchResultItemProps } from '../../../types/results';
import React from 'react';
import { trackResultItemClick } from '../../../utils/datalayer-events';

const SearchResultItem: React.FC<SearchResultItemProps> = ({
  hit,
  sendEvent,
}) => {
  if (!hit) {
    return null;
  }

  const title = hit.title || 'Untitled';
  const url = hit.url || '#';
  const description = hit.description || 'No description available';

  const handleClick = () => {
    try {
      sendEvent?.('click', hit, 'Hit Clicked');

      trackResultItemClick(
        hit.query || '',
        hit.__position || 0,
        title,
        url,
        'Search Results',
        'SearchResultItem',
      );
    } catch (error) {
      console.error('Failed to track search result click:', error);
    }
  };

  return (
    <>
      <article className="ee-search-result">
        <Heading size="s" level="3">
          <a href={url} onClick={handleClick} className="result-item-title">
            {title}
          </a>
        </Heading>
        <VerticalSpace size="16" />
        <Text tone="muted" elementType="p">
          <b>{description}</b>
        </Text>
        <VerticalSpace size="20" />
      </article>
      <div>
        <Rule orientation="horizontal" />
      </div>
    </>
  );
};

export default SearchResultItem;
